/* eslint-disable no-console */
import { call, put, select, takeLatest } from 'redux-saga/effects'

import api from './api'
import actions from './actions'
import { PROFILE_REWARDS_ANSWER_SOURCES } from './constants'
import { getFullUnveilAssociatedIds, getFullUnveilConflicts } from './selectors'

function* fetchProfileRewardsData({ payload }) {
  const { answerSource = PROFILE_REWARDS_ANSWER_SOURCES.ALL, callback } = payload
  let isSuccess = false
  try {
    const result = yield call(api.fetchProfileRewardsData, answerSource)
    yield put(actions.fetchProfileRewardsData.success(result))
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] fetchProfileRewardsData:', err)
    yield put(actions.fetchProfileRewardsData.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

function* updateProfileRewardsAnswer({ payload }) {
  const { questionId, answerText, selectedChoiceIds, callback } = payload
  let isSuccess = false
  try {
    const requestPayload = {
      answers: [
        ...(answerText ? [{ answer_text: answerText }] : []),
        ...(selectedChoiceIds.length > 0 ? selectedChoiceIds.map((choiceId) => ({ choice_id: choiceId })) : []),
      ],
    }
    const result = yield call(api.updateProfileRewardsAnswer, questionId, requestPayload)
    yield put(actions.updateProfileRewardsAnswer.success(result))
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] updateProfileRewardsAnswer:', err)
    yield put(actions.updateProfileRewardsAnswer.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

export function* fetchFullUnveil({ payload }) {
  const { callback } = payload
  let isSuccess = false
  let response = null

  try {
    response = yield call(api.fetchFullUnveil)
    const { attributesCount, profilesCount, questions, associatedIds, conflicts, breachData } = response
    yield put(
      actions.fetchFullUnveil.success(attributesCount, profilesCount, questions, associatedIds, conflicts, breachData),
    )
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] fetchFullUnveil:', err)
    yield put(actions.fetchFullUnveil.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, response)
    }
  }
}

export function* updateAssociatedIds({ payload }) {
  const { isAllHidden, callback } = payload
  let isSuccess = false
  let associatedIds = yield select(getFullUnveilAssociatedIds)
  if (isAllHidden) {
    associatedIds = associatedIds.map((associatedId) => ({ ...associatedId, isHidden: true }))
  }
  try {
    yield call(api.updateAssociatedIds, associatedIds)
    yield put(actions.updateAssociatedIds.success())
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] updateAssociatedIds:', err)
    yield put(actions.updateAssociatedIds.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

export function* updateFullUnveil({ payload }) {
  const { withConflictResolution, isSkipped, callback } = payload
  let isSuccess = false

  let conflictResolutions = null
  if (withConflictResolution && !isSkipped) {
    try {
      const conflicts = yield select(getFullUnveilConflicts)
      conflictResolutions = conflicts.map(({ question, options, selectedOptionIndex }) => ({
        question,
        selectedOption: options[selectedOptionIndex] ?? null,
      }))
    } catch (error) {
      console.error('[ProfileRewards] updateFullUnveil conflictResolutions:', error)
    }
  }

  try {
    yield call(api.updateFullUnveil, conflictResolutions, isSkipped)
    yield put(actions.updateFullUnveil.success())
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] updateFullUnveil:', err)
    yield put(actions.updateFullUnveil.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess)
    }
  }
}

export function* fetchBreachData({ payload }) {
  const { callback } = payload
  let isSuccess = false
  let response = null

  try {
    response = yield call(api.fetchBreachData)
    const {
      breachesCount,
      passwordsCount,
      breachesAttributesCount,
      isDataBreachesScanned,
      idBreaches,
      isProspectDataBreachesScanned,
      isProspectDataBreachesFound,
    } = response
    yield put(
      actions.fetchBreachData.success(
        breachesCount,
        passwordsCount,
        breachesAttributesCount,
        isDataBreachesScanned,
        idBreaches,
        isProspectDataBreachesScanned,
        isProspectDataBreachesFound,
      ),
    )
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] fetchBreachData:', err)
    yield put(actions.fetchBreachData.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, response)
    }
  }
}

export function* fetchUnveilNotificationSummary({ payload }) {
  const { callback } = payload
  let isSuccess = false
  let response = null

  try {
    response = yield call(api.fetchUnveilNotificationSummary)
    yield put(actions.fetchUnveilNotificationSummary.success(response))
    isSuccess = true
  } catch (err) {
    console.error('[ProfileRewards] fetchUnveilNotificationSummary:', err)
    yield put(actions.fetchUnveilNotificationSummary.failure())
  } finally {
    if (callback) {
      yield call(callback, isSuccess, response)
    }
  }
}

export default function* main() {
  yield takeLatest(actions.fetchProfileRewardsData.INIT_TYPE, fetchProfileRewardsData)
  yield takeLatest(actions.updateProfileRewardsAnswer.INIT_TYPE, updateProfileRewardsAnswer)
  yield takeLatest(actions.fetchFullUnveil.INIT_TYPE, fetchFullUnveil)
  yield takeLatest(actions.updateFullUnveil.INIT_TYPE, updateFullUnveil)
  yield takeLatest(actions.updateAssociatedIds.INIT_TYPE, updateAssociatedIds)
  yield takeLatest(actions.fetchBreachData.INIT_TYPE, fetchBreachData)
  yield takeLatest(actions.fetchUnveilNotificationSummary.INIT_TYPE, fetchUnveilNotificationSummary)
}
